import React from "react";

import "./Spinner.scss";

import { ReactComponent as SvgRadar } from "./radar.svg";

function Spinner() {
  return (
    <SvgRadar className="spinner"/>
  );
}

export default Spinner;
